import { render, staticRenderFns } from "./Catecourse.vue?vue&type=template&id=3ce660e2&scoped=true"
import script from "./Catecourse.vue?vue&type=script&lang=js"
export * from "./Catecourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce660e2",
  null
  
)

export default component.exports